module.exports = __webpack_public_path__ + "img/room-multimedia.a8797caa.jpg";